export default __webpack_public_path__ + "static/media/transform-lifes-2-colombia.08b33f47.png";